// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".forgot-password-page .nav-link{padding:0}.forgot-password-page a{color:#fff}", ""]);
// Exports
module.exports = exports;
